/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API25087Item {
  
  /** 文件名称 */
  fileName?: string;
  
  /** url */
  url?: string;
  
};
    
  



export interface API25087Req {
  
  /**  */
  files: string;
};



export interface API25087Res {
  /**   */
  hasNext?: any;
  /**   */
  list?: API25087Item[];
  /**   */
  pageIndex?: any;
  /**   */
  pageSize?: any;
  /**   */
  rowId?: any;
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  
};


// 25087 文件上传接口

export interface IUsePostAPI25087Return {
  /** 文件上传接口: 接口请求状态 */
  isAPI25087Loading: boolean;
  /** 文件上传接口: 接口请求返回数据 */
  dataAPI25087: API25087Res;
  /**  文件上传接口: 接口数据请求方法 */
  fetchAPI25087Data:  (inputs: API25087Req, config?: YWRequestConfig) => Promise<API25087Res>;
  /** 文件上传接口: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI25087 = ():IUsePostAPI25087Return => {
  let isMount = true;
  const [isAPI25087Loading, setIsAPI25087Loading] = useState(false);
  const [dataAPI25087, setDataAPI25087] = useState<API25087Res>({} as API25087Res);
  const requestUrl = `${basePath}/ywwl-admin/question/feedback/upload`;

  const fetchAPI25087Data = async (inputs: API25087Req, config?: YWRequestConfig): Promise<API25087Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API25087Req>) || {}) as API25087Req;
    
  
    if ( isMount ) {
      setIsAPI25087Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API25087Res>(`${basePath}/ywwl-admin/question/feedback/upload`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI25087(res || {} as API25087Res);
        setIsAPI25087Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI25087Loading(false);
      }
      return false as unknown as API25087Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI25087Loading,
    dataAPI25087,
    fetchAPI25087Data,
    requestUrl,
  }
}

